// Runs before the application graph. Keep this the first import in index.ts:
// ES imports are hoisted, so a statement in index.ts would execute only after
// every imported module, including web-auth-lib's Zod schemas, is evaluated.
import { z } from 'zod';

// Zod caches the result of its first `Function` probe, and under a strict
// script-src the caught probe still reports a violation. jitless skips it.
z.config({ jitless: true });
